module.exports = "../../app/cells/pages/rankings/subscriptions/show/cta_status_based_cell.rb";